import { CARD_PHONE_AUTH_AND_T2C_MSG, CARD_PHONE_AUTH_MSG, CARD_T2C_MSG, CHANGES_SAVED_MSG, STOPPED_CARD_ALL_AUTH_MSG, STOPPED_CARD_PHONE_AUTH_MSG, STOPPED_CARD_T2C_MSG, } from '../constants/response-success-messages';
import { CNP_ENROLLMENT_ACTIONS, } from '../models/b2b/payments';
import { newrelic } from './newrelic';
import { setOtherButtonSubmissionAnalytics } from './payments-analytics';
export const changePhoneAuthText = (showConfigurableCardsInfo) => {
    if (showConfigurableCardsInfo) {
        return '(Required for Text2Confirm and Pro Allowance)';
    }
    return '(Required for Text2Confirm)';
};
export const cnpEnrollmentSuccessNewRelic = (data) => {
    if (data.stopT2CSuccess) {
        newrelic.addPageAction('remote-purchases-stop-t2c', {
            result: 'success',
        });
    }
    if (data.stopPAASuccess) {
        newrelic.addPageAction('remote-purchases-stop-paa', {
            result: 'success',
        });
    }
    if (data.authorizePAASuccess || data.enrollT2CSuccess) {
        newrelic.addPageAction('remote-purchases-enrollment', {
            result: 'success',
        });
    }
};
export const getAlertSuccessMessage = (action, isProxCard) => {
    switch (action) {
        case 'REMOVE_PHONE_AUTH':
        case 'REMOVE_PHONE_AUTH_AND_T2C':
            return isProxCard
                ? STOPPED_CARD_PHONE_AUTH_MSG
                : STOPPED_CARD_ALL_AUTH_MSG;
        case 'REMOVE_T2C':
            return STOPPED_CARD_T2C_MSG;
        case 'PHONE_AUTH':
            return CARD_PHONE_AUTH_MSG;
        case 'PHONE_AUTH_AND_T2C':
            return CARD_PHONE_AUTH_AND_T2C_MSG;
        case 'T2C':
            return CARD_T2C_MSG;
        default:
            return CHANGES_SAVED_MSG;
    }
};
export const getRequestData = (isInitialFlow, values, defaultValues) => {
    if (isInitialFlow) {
        const isPhoneAuthAndT2CAdded = values.phoneCheckbox && values.t2cCheckbox;
        if (isPhoneAuthAndT2CAdded) {
            return {
                requestAction: CNP_ENROLLMENT_ACTIONS.T2C,
                action: 'PHONE_AUTH_AND_T2C',
            };
        }
        const isPhoneAuthOnlyAdded = values.phoneCheckbox && !values.t2cCheckbox;
        if (isPhoneAuthOnlyAdded) {
            return {
                requestAction: CNP_ENROLLMENT_ACTIONS.PHONE_AUTH,
                action: 'PHONE_AUTH',
            };
        }
        return null;
    }
    const uncheckedPhoneAuth = !values.phoneCheckbox;
    if (uncheckedPhoneAuth) {
        return {
            requestAction: defaultValues.t2cCheckbox
                ? CNP_ENROLLMENT_ACTIONS.REMOVE_PHONE_AUTH_AND_T2C
                : CNP_ENROLLMENT_ACTIONS.REMOVE_PHONE_AUTH,
            action: defaultValues.t2cCheckbox
                ? 'REMOVE_PHONE_AUTH_AND_T2C'
                : 'REMOVE_PHONE_AUTH',
        };
    }
    const uncheckedT2C = values.phoneCheckbox && defaultValues.t2cCheckbox && !values.t2cCheckbox;
    if (uncheckedT2C) {
        return {
            requestAction: CNP_ENROLLMENT_ACTIONS.REMOVE_T2C,
            action: 'REMOVE_T2C',
        };
    }
    const isT2CAdded = !defaultValues.t2cCheckbox && values.t2cCheckbox;
    if (isT2CAdded) {
        return { requestAction: CNP_ENROLLMENT_ACTIONS.T2C, action: 'T2C' };
    }
    const isT2CNumberChanged = defaultValues.t2cCheckbox &&
        values.t2cCheckbox &&
        defaultValues.phoneNumber !== values.phoneNumber;
    if (isT2CNumberChanged) {
        return {
            requestAction: CNP_ENROLLMENT_ACTIONS.T2C,
            action: 'T2C_NUMBER_UPDATE',
        };
    }
    const areApproversPresent = values.t2cCheckbox && values.additionalApprovers.length > 0;
    if (areApproversPresent) {
        return {
            requestAction: CNP_ENROLLMENT_ACTIONS.T2C,
            action: 'T2C',
        };
    }
    return null;
};
export const onTooltipClick = (remotePurchaseOption) => {
    setOtherButtonSubmissionAnalytics(`credit cards: approve by ${remotePurchaseOption.toLowerCase()} tooltip`);
};
